// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const InfoSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M16 8a8 8 0 108 8 8.01 8.01 0 00-8-8zm0 15a7 7 0 117-7 7.009 7.009 0 01-7 7z" />
      <path d="M16.473 14.43h-.946V20h.946v-5.57zM16.56 12h-1.12v1.111h1.12V12z" />
    </svg>
  )
}
